<!--  -->
<template>
  <div>
    <!-- header 导航栏 -->
    <div class="nav">
      <div
        style="
          width: 233px;
          height: 80px;

          display: flex;
          flex-direction: column;
          justify-content: center;
        "
      >
        <div style="display: flex; align-items: center">
          <img
            src="../assets/第一生命首页繁体_slices/矢量智能对象.png"
            alt=""
            style="width: 42px; height: 41px"
          />
          <div   style="height: 17px; margin-left: 15px">
            第一生命香港有限会社
          </div>
          <!-- <img
            src="../assets/第一生命首页繁体_slices/第一生命香港有限公司.png"
            alt=""
            style="height: 17px; margin-left: 15px"
          /> -->
        </div>
        <!-- <div
          style="
            margin-left: 10px;
            font-weight: 400;
            color: #fff;
            font-size: 20px;
          "
        >
          博爱医药
        </div> -->
      </div>
      <div>
        <ul class="center">
          <li @click="btnClick(1)">
            <a :class="{ active: itemIndex == 1 }">トップページ</a> |
          </li>
          <li>
            <a :class="{ active: itemIndex == 2 }" @click="btnClick(2)"
              >会社情報</a
            >
            |
          </li>
          <li @click="btnClick(3)">
            <a :class="{ active: itemIndex == 3 }">人材募集</a> |
          </li>
          <li @click="btnClick(4)">
            <a :class="{ active: itemIndex == 4 }">お問合せ</a>
          </li>
        </ul>
      </div>
    </div>
    <!-- 1是首页  2是关于我们 3是会员服务 4是博爱大事记 5是供应商平台 6是人才招聘-->
    <div v-if="this.itemIndex == 1">
      <!-- banner -->
      <div class="top-rowBanner"></div>

      <!-- 会社案内 -->
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          padding: 100px 0;
        "
      >
        <!-- left -->
        <div
          style="
            width: 1000px;
            height: 259px;
            display: flex;
            justify-content:space-between
          
         
          "
        >
          <!-- right -->
          <div>
            <div>
              <img
              src="../assets/第一生命首页日文_slices/会社概要.png"
                alt=""
                style="width: 105px; height: 21px"
              />
              <img
                src="../assets/香港首页繁体_slices/Company Profile.png"
                alt=""
                style="margin-left: 20px; height: 13px"
              />
            </div>
            <div style="margin-top: 20px; color: #246ef6"><B>_______</B></div>
            <div>
              <!-- <img
                src="../assets/香港首页繁体_slices/营口博爱医药连锁有限公司坐落于辽宁省营口市，是一家集零售、批发与电商于一体的综合性医药企业，覆盖线下连锁+线上B2C电商+批发.png"
                alt=""
                style="margin-top: 40px; height: 225px; width: 560px"
              /> -->
              <div    style="margin-top: 40px; height: 225px; width: 660px;letter-spacing:2px;color:grey">
                営口博愛医薬チェーン有限会社は遼寧省営口市にある小売販売、医薬品卸販売とEC販売を一体化した総合医薬企業です。営口地域で120軒の店舗を展開しています。EC販売は天猫Tmall（博愛大薬局旗艦店、元沛堂大薬局旗艦店）及び京東JD.com、拼多多PIN DUODUOなど、年間合計売上高は約16億円。そのうち天猫Tmallは約2億５千万円。また、同社の遼寧格列安器薬株式会社は医薬品卸販売会社で経営しており、中国の医薬品卸販売業務を行っており、年間売上高は約107億円に達しています。総従業員数は約480人で、効率的な運営と持続的な革新を続けています。2023年には国境を越えOTC販売を進出しており、現在は香港支社、日本支社により輸入業務を行っています。
              </div>
            </div>
          </div>
          <!-- left -->
          <div>
            <img
              src="../assets/第一生命首页繁体_slices/图层 10.png"
              alt=""
              style="width: 420px; height: 340px"
            />
          </div>
        </div>
      </div>

      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          background:#EEF2F6;
          padding-bottom:50px
        "
      >
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 1000px;
          "
        >
          <div
            style="
              width: 1000px;
              display: flex;
              justify-content: center;
              align-items:end
              color: #0762cb;

            margin-top:80px
            "
          >
            <img
            src="../assets/第一生命首页日文_slices/中国本社.png"
              alt=""
              style="width: 115px; height: 21px"
            />
          </div>
        </div>
        <div style="color: #246ef6"><B>_______</B></div>
        <div style="margin-top: 20px">
          <img
            src="../assets/香港首页繁体_slices/head office.png"
            alt=""
            style="width: 130px; height: 13px; margin-left: 15px"
          />
        </div>
        <div
          style="
            width: 1000px;
            height: 259px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 45px;
            /* border:1px solid red */
          "
        >
          <img
            src="../assets/1.jpg"
            alt=""
            style="width: 320px; height: 220px"
          />
          <img
            src="../assets/2.jpg"
            alt=""
            style="width: 320px; height: 220px"
          />
          <img
            src="../assets/3jpg.jpg"
            alt=""
            style="width: 320px; height: 220px"
          />
        </div>
        <div
          style="
            width: 1000px;
            height: 259px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 5px;
           
            /* border:1px solid red */
          "
        >
          <img
            src="../assets/首页_slices/图层 20.png"
            alt=""
            style="width: 320px; height: 220px"
          />
          <img
            src="../assets/首页_slices/图层 22.png"
            alt=""
            style="width: 320px; height: 220px"
          />
          <img
            src="../assets/首页_slices/图层 23.png"
            alt=""
            style="width: 320px; height: 220px"
          />
        </div>
      </div>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        "
      >
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 1000px;
          "
        >
          <div
            style="
              width: 1000px;
              display: flex;
              justify-content: center;
              align-items:end
              color: #0762cb;

            margin-top:100px
            "
          >
            <img
            src="../assets/第一生命首页日文_slices/8つのメリット.png"
              alt=""
              style="width: 110px; height: 21px"
            />
          </div>
        </div>
        <div style="color: #246ef6"><B>_______</B></div>
        <div style="margin-top: 20px">
          <img
          src="../assets/第一生命首页日文_slices/健康で楽しい.png"
            alt=""
            style="width: 140px; height: 20px; margin-left: 7px"
          />
        </div>
        <div
          style="
            width: 1000px;

            display: flex;

            align-items: center;

            margin-top: 30px;
            justify-content: space-between;
            /* border:1px solid red */
          "
        >
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              height: 120px;
              width: 300px;
              justify-content: space-around;
            "
          >
            <div
              style="
                width: 70px;
                height: 70px;
                border-radius: 40px;
                background: #0762cb;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img
                src="../assets/香港首页繁体_slices/1.png"
                alt=""
                style="width: 39px"
              />
            </div>

            <!-- <img
              src="../assets/第一生命首页日文_slices/国家認証資格がそ ろっている.png"
              alt=""
              style="width: 120px"
            /> -->
            <div   style="width: 120px;font-size:13px;display: flex;
                justify-content: center;
                align-items: center;">
              適法性
            </div>
          </div>

          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              height: 120px;
              width: 300px;
              justify-content: space-around;
            "
          >
            <div
              style="
                width: 70px;
                height: 70px;
                border-radius: 40px;
                background: #0762cb;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img
                src="../assets/香港首页繁体_slices/2.png"
                alt=""
                style="width: 39px"
              />
            </div>

             <!-- <img
              src="../assets/第一生命首页日文_slices/薬企業が直接正規品を 採取して保証する.png"
              alt=""
              style="width: 120px"
            />  -->
            <div   style="width: 160px;font-size:13px;display: flex;
                justify-content: center;
                align-items: center;">
              メーカー品質保証
            </div>
          </div>

          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              height: 120px;
              width: 300px;
              justify-content: space-around;
            "
          >
            <div
              style="
                width: 70px;
                height: 70px;
                border-radius: 40px;
                background: #0762cb;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img
                src="../assets/香港首页繁体_slices/3.png"
                alt=""
                style="width: 39px"
              />
            </div>

            <!-- <img
              src="../assets/第一生命首页日文_slices/職業薬剤師のオン ライン相談.png"
              alt=""
              style="width: 120px"
            />  -->
            <div   style="width: 160px;font-size:13px;display: flex;
                justify-content: center;
                align-items: center;">
              薬剤師オンライ相談
            </div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              height: 120px;
              width: 300px;
              justify-content: space-around;
            "
          >
            <div
              style="
                width: 70px;
                height: 70px;
                border-radius: 40px;
                background: #0762cb;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img
                src="../assets/香港首页繁体_slices/4.png"
                alt=""
                style="width: 39px"
              />
            </div>

             <!-- <img
              src="../assets/第一生命首页日文_slices/安心薬のプライ バシー配送.png"
              alt=""
              style="width: 120px"
            />  -->
            <div   style="width: 160px;font-size:13px;display: flex;
                justify-content: center;
                align-items: center;">
              匿名配送
            </div>
          </div>
        </div>
        <div
          style="
            width: 1000px;

            display: flex;

            align-items: center;

            margin-top: 30px;
            justify-content: space-between;
            /* border:1px solid red */
          "
        >
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: space-around;
            "
          >
            <div
              style="
                width: 250px;
                height: 370px;
                background: #0762cb;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
              "
            >
              <img
                src="../assets/香港首页繁体_slices/1-1.png"
                alt=""
                style="width: 69px"
              />
              <!-- <img
                src="../assets/香港首页繁体_slices/实力保障 多家线下门店.png"
                alt=""
                style="width: 120px; margin-top: 15px"
              /> -->
              <div   style="width: 120px; margin-top: 15px;color:white;margin-left:27px">
                多店舗展開
            </div>
            </div>
          </div>

          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: space-around;
            "
          >
            <div
              style="
                width: 249px;
                height: 370px;
                background: #0762cb;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
              "
            >
              <img
                src="../assets/香港首页繁体_slices/2-2.png"
                alt=""
                style="width: 69px"
              />
              <!-- <img
                src="../assets/香港首页繁体_slices/药品种类齐全.png"
                alt=""
                style="width: 120px; margin-top: 15px"
              /> -->
              <div   style="width: 120px; margin-top: 15px;color:white">
                豊富な品揃え
            </div>
            </div>
          </div>

          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: space-around;
            "
          >
            <div
              style="
                width: 249px;
                height: 370px;
                background: #0762cb;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
              "
            >
              <img
                src="../assets/香港首页繁体_slices/3-3.png"
                alt=""
                style="width: 69px;"
              />
              <div   style="width: 120px; margin-top:15px;color:white">
                便利なオンライン注文
            </div>
            </div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: space-around;
            "
          >
            <div
              style="
                width: 249px;
                height: 370px;
                background: #0762cb;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
              "
            >
              <img
                src="../assets/香港首页繁体_slices/4-4.png"
                alt=""
                style="width: 69px"
              />
              <!-- <img
                src="../assets/香港首页繁体_slices/医疗咨询 各种各样的保障.png"
                alt=""
                style="width: 120px; margin-top: 15px"
              /> -->
              <div   style="width: 120px; margin-top: 15px;color:white">
                無料相談対応
            </div>
            </div>
          </div>
        </div>
      
      </div>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        "
      >
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 1000px;
          "
        >
          <div
            style="
              width: 1000px;
              display: flex;
              justify-content: center;
              align-items:end
              color: #0762cb;

            margin-top:100px
            "
          >
            <img
              src="../assets/第一生命首页日文_slices/サービス項目.png"
              alt=""
              style="width: 135px; height: 27px"
            />
            <!-- <div  style="width: 135px;margin-left:40px">サービス項目</div> -->
          </div>
        </div>
        <div style="color: #246ef6"><B>_______</B></div>
        <div style="margin-top: 20px">
          <img
            src="../assets/香港首页繁体_slices/Service Items.png"
            alt=""
            style="width: 140px; height: 15px; margin-left: 7px"
          />
        </div>
        <div style="width: 1000px; margin-top: 30px">
          <img src="../assets/不动产网页-会社概要_slices/组 1.png" alt="" style="width: 1000px" />
        </div>
      </div>
      <!-- footer -->
      <div
        class="footerBanner"
        style="
          width: 100%;
          height: 300px;

          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 100px;
        "
      >
        <div
          style="
            width: 1000px;
            height: 280px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div style="width:1000px;height:270px;background-color:rgba(254,254,254,0.65);margin-top:30px;display:flex">
         <div>
             <!-- 1 -->
             <div style="display: flex; align-items: center;margin-left:45px;margin-top:25px">
              <img
                src="../assets/第一生命首页繁体_slices/矢量智能对象.png"
                alt=""
                style="width:35px; height:32px"
              />
              <!-- <img
                src="../assets/第一生命首页繁体_slices/第一生命香港有限公司(1).png"
                alt=""
                style="height: 17px; margin-left: 15px"
              /> -->
              <div  style="height: 17px; margin-left: 15px">
                第一生命香港有限会社
              </div>
            </div>
            <!-- 2 -->
            <div style="width:560px;margin-left:45px;margin-top:20px">
              笑顔で全てのお客様と向き合い、誠意を持ってサービスを提供します。小さなことから始め、細かく携わって、熱意と根気でお客様に満足を、誠意と愛情でお客様を感動を、常に心を込めて接客します。
              <!-- <img src="../assets/香港首页繁体_slices/微笑面对每一位顾客，诚恳服务每一位顾客，从小事做起、从细节着手，用热心和耐心温暖顾客； 用诚心和爱心感动顾客；用心、尽心奉献于.png" alt="" style="width:560px;margin-left:45px;margin-top:28px"> -->
            </div>
            <!-- 3 -->
            <div>
              <img src="../assets/香港首页繁体_slices/中国总公司： 营口博爱医药连锁有限公司：http：／／www.boaiyiyao.com  日本分公司： 株式会社政轩：htt.png" alt="" style="width:320px;margin-left:45px;margin-top:28px" >
            </div>
         </div>
         <div style="margin-left:240px;margin-top:115px;display:flex;align-items:center;flex-direction:column">
          <img src="../assets/香港首页繁体_slices/图层 19.png" alt="">
          <img src="../assets/香港首页繁体_slices/博爱公众号.png" alt="">
         </div>
          </div>
        </div>
      </div>
      <div style="width:100%;height:60px;background:#2C445C;display:flex;justify-content:center;align-items:center">
          <div style="width:1000px;height:40px;display:flex;align-items:center;justify-content:space-around;color:white">
          <div>トップページ</div>
          <div>会社情報</div>
          <div>人材募集</div>
          <div>お問合せ</div>
          </div>
      </div>
    </div>
    <div v-if="this.itemIndex == 2">
      <!-- banner -->
      <div class="top-rowBanner1111">
        <div style="margin-left:45%">
          <div><img src="../assets/第一生命关于我们繁体_slices/About Us.png" alt="" style="width:200px;margin-top:200px"></div>
        <div style="width:120px;margin-left:56px;margin-top:10px;height:16px;color:white;font-size:22px">
          <!-- <img src="../assets/第一生命首页日文_slices/私たちについて.png" alt="" style="width:120px;margin-left:50px;margin-top:10px;height:16px"> -->
          会社情報
        </div>
        </div>
      </div>

      <!-- 医院环境 -->
      <div style="display: flex; justify-content: center">
        <div
          style="
            display: flex;
            align-items:center;
            justify-content:space-around;
            width: 1000px;
          
            height: 300px;
            margin-top:50px;
            flex-direction:column
          "
        >
       <div style="display:flex;padding-top:60px">
        <div  style="width:4px;height:18px;background:#0762CB"></div>
         <img  src="../assets/第一生命首页日文_slices/会社概要.png" alt="" style="width:100px;height:21px;margin-left:10px;margin-top:7px">
       </div>
       <div>
        <!-- <img src="../assets/第一生命关于我们繁体_slices/营口博爱医药连锁有限公司坐落于辽宁省营口市，是一家集零售、批发与电商于一体的综合性医药企业，覆盖线下连锁+线上B2C电商+批发.png" alt="" style="width:1000px;"> -->
      <div  style="width:1000px;color:grey;letter-spacing:1.5px">
        営口博愛医薬チェーン有限会社は遼寧省営口市にある小売販売、医薬品卸販売とEC販売を一体化した総合医薬企業です。営口地域で120軒の店舗を展開しています。EC販売は天猫Tmall（博愛大薬局旗艦店、元沛堂大薬局旗艦店）及び京東JD.com、拼多多PIN DUODUOなど、年間合計売上高は約16億円。そのうち天猫Tmallは約2億５千万円。また、同社の遼寧格列安器薬株式会社は医薬品卸販売会社で経営しており、中国の医薬品卸販売業務を行っており、年間売上高は約107億円に達しています。総従業員数は約480人で、効率的な運営と持続的な革新を続けています。2023年には国境を越えOTC販売を進出しており、現在は香港支社、日本支社により輸入業務を行っています。

      </div>
      </div>
        </div>

      </div>
      <div>
        <img src="../assets/第一生命关于我们繁体_slices/图层 25.png" alt="" style="width:100%;height:440px;margin-top:20px">
      </div>

      <div style="display: flex; justify-content: center">
        <div
          style="
            display: flex;
            align-items:center;
            justify-content:space-around;
            width: 1000px;
          
            height: 300px;
            margin-top:50px;
            flex-direction:column
          "
        >
       <div style="display:flex;">
        <div  style="width:4px;height:18px;background:#0762CB"></div>
        <div style="width:220px;height:21px;margin-left:10px;margin-top:2px;color:#0762CB;font-size:22px">商品販売企画と強み</div>
         <!-- <img src="../assets/第一生命首页日文_slices/製品計画と利点.png" alt="" style="width:180px;height:21px;margin-left:10px;margin-top:13px"> -->
       </div>
       <div style="width:1000px;letter-spacing:2px;color:grey">
        ①香港、日本及びオーストラリアの市販薬品、サプリメント、医療機器は博愛医薬の直営店で販売を実施します。QRコードの読取で注文と配送対応可能です(一店舗の平均売上4000円/日で、年間売上は約1億7200万円に達します)また、EC販売も同時に販促します。②オリジナル製品と特注品は中国本社を通して、同仁堂、馬応龍、広誉遠、九芝堂などのメーカーと協力し、輸出向けオリジナル商品と国内販売用オリジナル商品(香港製安宮牛黄丸三丸、香港製ロバ膠補血顆粒など)を生産します。 ③日本支社で日本向けオリジナル漢方薬を(八位地黄丸、六君子湯など)生産します。       </div>
        </div>

      </div>

      
      <div style="display:flex;justify-content:center;align-items:center">
        <div style="display:flex;">
        <div  style="width:4px;height:18px;background:#0762CB"></div>
         <!-- <img src="../assets/第一生命首页日文_slices/運用上のメリット.png" alt="" style="width:120px;height:21px;margin-left:10px;margin-top:13px"> -->
         <div style="width:120px;height:21px;margin-left:10px;margin-top:1px;color:#0762CB;font-size:22px">運営理念</div>
       </div>
    
    </div>
    <div style="display:flex;justify-content:center;align-items:center">
      <div style="width:1000px;display:flex;justify-content:space-between">
        <div style="position:relative">
          <img src="../assets/香港关于我们_slices/矩形 18 拷贝.png" alt="" style="width:330px;height:400px;">
         
          <img src="../assets/香港关于我们_slices/3.png" alt="" style="width:268px;position:absolute;top:28px;left:30px;height:200px">
          <div style="position:absolute;top:193px;left:60px;width:60px;height:60px;border-radius:50%;background:#246EF6;display:flex;justify-content:center;align-items:center">
          <img src="../assets/香港关于我们_slices/1-1.png" alt="" style="width:37px;height:27px">
          </div>
          <div  style="position:absolute;top:263px;left:50px;width:230px;height:60px;font-size:12px;color:grey">
            <!-- <img src="../assets/第一生命关于我们繁体_slices/专业电商团队.png" alt="" style="width:100px;"> -->
            <div style="width:200px;font-size:16px;color:black">EC販売チームの実力</div>
          </div>
          <div  style="position:absolute;top:288px;left:50px;width:230px;height:60px;font-size:12px;color:grey">
            EC販売専属チームは約60人所属し、運営経験が豊富です。
          </div>
        </div>
  
        <div style="position:relative">
          <img src="../assets/香港关于我们_slices/矩形 18 拷贝.png" alt="" style="width:330px;height:400px;">
    
          <img src="../assets/香港关于我们_slices/4.png" alt="" style="width:268px;position:absolute;top:28px;left:30px;height:200px">
          <div style="position:absolute;top:193px;left:60px;width:60px;height:60px;border-radius:50%;background:#246EF6;display:flex;justify-content:center;align-items:center">
          <img src="../assets/香港关于我们_slices/2-2.png" alt="" style="width:30px;height:30px">
          </div>
          <div  style="position:absolute;top:263px;left:50px;width:230px;height:60px;font-size:12px;color:grey">
            <!-- <img src="../assets/第一生命关于我们繁体_slices/全球采购与物流.png" alt="" style="width:100px;">
             -->
             <div style="width:200px;font-size:16px;color:black">仕入と物流</div>
          </div>
          <div style="position:absolute;top:288px;left:50px;width:230px;height:60px;font-size:12px;color:grey">
            香港と日本の購買部から直仕入でコストを抑え、専属物流で市場のニーズに応じて商品の確保と提供ができる

          </div>
        </div>
        <div style="position:relative">
          <img src="../assets/香港关于我们_slices/矩形 18 拷贝.png" alt="" style="width:330px;height:400px;">
   
          <img src="../assets/香港关于我们_slices/5.png" alt="" style="width:268px;position:absolute;top:28px;left:30px;height:200px">
          <div style="position:absolute;top:193px;left:60px;width:60px;height:60px;border-radius:50%;background:#246EF6;display:flex;justify-content:center;align-items:center">
          <img src="../assets/香港关于我们_slices/3-3.png" alt="" style="width:35px;height:27px">
          </div>
          <div  style="position:absolute;top:263px;left:50px;width:230px;height:60px;font-size:12px;color:grey">
            <!-- <img src="../assets/第一生命关于我们繁体_slices/采用线下连锁店.png" alt="" style="width:100px;"> -->
            <div style="width:200px;font-size:16px;color:black">直営チェーン店の力</div>
          </div>
          <div style="position:absolute;top:288px;left:50px;width:230px;height:60px;font-size:12px;color:grey">
            国内直営チェーン店からグローバル化へ拡大

          </div>
        </div>


</div>
    </div>
  <!-- footer -->
  <div
        class="footerBanner"
        style="
          width: 100%;
          height: 300px;

          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 100px;
        "
      >
        <div
          style="
            width: 1000px;
            height: 280px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div style="width:1000px;height:270px;background-color:rgba(254,254,254,0.65);margin-top:30px;display:flex">
         <div>
             <!-- 1 -->
             <div style="display: flex; align-items: center;margin-left:45px;margin-top:25px">
              <img
                src="../assets/第一生命首页繁体_slices/矢量智能对象.png"
                alt=""
                style="width:35px; height:32px"
              />
              <!-- <img
                src="../assets/第一生命首页繁体_slices/第一生命香港有限公司.png"
                alt=""
                style="height: 17px; margin-left: 15px"
              /> -->
              <div  style="height: 17px; margin-left: 15px">
                第一生命香港有限会社
              </div>
            </div>
            <!-- 2 -->
            <div style="width:560px;margin-left:45px;margin-top:20px">
              笑顔で全てのお客様と向き合い、誠意を持ってサービスを提供します。小さなことから始め、細かく携わって、熱意と根気でお客様に満足を、誠意と愛情でお客様を感動を、常に心を込めて接客します。
              <!-- <img src="../assets/香港首页繁体_slices/微笑面对每一位顾客，诚恳服务每一位顾客，从小事做起、从细节着手，用热心和耐心温暖顾客； 用诚心和爱心感动顾客；用心、尽心奉献于.png" alt="" style="width:560px;margin-left:45px;margin-top:28px"> -->
            </div>
            <!-- 3 -->
            <div>
              <img src="../assets/香港首页繁体_slices/中国总公司： 营口博爱医药连锁有限公司：http：／／www.boaiyiyao.com  日本分公司： 株式会社政轩：htt.png" alt="" style="width:320px;margin-left:45px;margin-top:28px" >
            </div>
         </div>
         <div style="margin-left:240px;margin-top:115px;display:flex;align-items:center;flex-direction:column">
          <img src="../assets/香港首页繁体_slices/图层 19.png" alt="">
          <img src="../assets/香港首页繁体_slices/博爱公众号.png" alt="">
         </div>
          </div>
        </div>
      </div>
      <div style="width:100%;height:60px;background:#2C445C;display:flex;justify-content:center;align-items:center">
          <div style="width:1000px;height:40px;display:flex;align-items:center;justify-content:space-around;color:white">
            <div>トップページ</div>
          <div>会社情報</div>
          <div>人材募集</div>
          <div>お問合せ</div>
          </div>
      </div>
    </div>
    <div v-if="this.itemIndex == 4">
      <!-- banner -->
      <div class="top-rowBanner222222">
        <div style="margin-left:45%">
          <div><img src="../assets/第一生命关于我们繁体_slices/Contact Us.png" alt="" style="width:200px;margin-top:200px"></div>
        <div>
          <!-- <img src="../assets/第一生命关于我们繁体_slices/联系我们.png" alt="" style="width:100px;margin-left:50px;margin-top:10px"> -->
          <div style="width:100px;margin-left:55px;margin-top:10px;color:white;font-size:22px">お問合せ</div>
        </div>
        </div>
      </div>
      <!-- 关于博爱 -->

      <!-- 四大优势 -->
<div style="display:flex;justify-content:center;align-items:center">
<div style="width:1000px;height:290px;margin-top:60px"> 
<img src="../assets/lxwm1.png" alt="" style="width:1000px;height:290px;position: relative;">``
<img src="../assets/联系我们_slices/Contact.png" alt="" style="position:absolute;top:720px;z-index:999;left:500px;width:120px">
<div style="position:absolute;top:756px;z-index:999;left:500px;width:270px">
  第一生命香港有限会社</div>
<div style="position:absolute;top:790px;z-index:999;left:500px;width:270px"><b>______</b></div>
<div style="position:absolute;top:837px;z-index:999;left:500px;width:570px;letter-spacing:1.5px">TEL:18141702222</div>
<div style="position:absolute;top:870px;z-index:999;left:500px;width:570px;letter-spacing:1.5px">地  址：荃灣半山街10-16號富華工業大廈7/F樓B座(肆拾柒)室</div>
<div style="position:absolute;top:900px;z-index:999;left:500px;width:870px;letter-spacing:1.5px;">お客様満足度を高めるために、お客様への感謝の気持ちを忘れずに、日々努力していきます。</div>

</div>
</div>
  

   <!-- footer -->
   <div
        class="footerBanner"
        style="
          width: 100%;
          height: 300px;

          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 60px;
        "
      >
        <div
          style="
            width: 1000px;
            height: 280px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div style="width:1000px;height:270px;background-color:rgba(254,254,254,0.65);margin-top:30px;display:flex">
         <div>
             <!-- 1 -->
             <div style="display: flex; align-items: center;margin-left:45px;margin-top:25px">
              <img
                src="../assets/第一生命首页繁体_slices/矢量智能对象.png"
                alt=""
                style="width:35px; height:32px"
              />
              <!-- <img
                src="../assets/第一生命首页繁体_slices/第一生命香港有限公司.png"
                alt=""
                style="height: 17px; margin-left: 15px"
              /> -->
              <div style="height: 17px; margin-left: 15px">
                第一生命香港有限会社
              </div>
            </div>
            <!-- 2 -->
            <div style="width:560px;margin-left:45px;margin-top:20px">
              笑顔で全てのお客様と向き合い、誠意を持ってサービスを提供します。小さなことから始め、細かく携わって、熱意と根気でお客様に満足を、誠意と愛情でお客様を感動を、常に心を込めて接客します。
              <!-- <img src="../assets/香港首页繁体_slices/微笑面对每一位顾客，诚恳服务每一位顾客，从小事做起、从细节着手，用热心和耐心温暖顾客； 用诚心和爱心感动顾客；用心、尽心奉献于.png" alt="" style="width:560px;margin-left:45px;margin-top:28px"> -->
            </div>
            <!-- 3 -->
            <div>
              <img src="../assets/香港首页繁体_slices/中国总公司： 营口博爱医药连锁有限公司：http：／／www.boaiyiyao.com  日本分公司： 株式会社政轩：htt.png" alt="" style="width:320px;margin-left:45px;margin-top:28px" >
            </div>
         </div>
         <div style="margin-left:240px;margin-top:115px;display:flex;align-items:center;flex-direction:column">
          <img src="../assets/香港首页繁体_slices/图层 19.png" alt="">
          <img src="../assets/香港首页繁体_slices/博爱公众号.png" alt="">
         </div>
          </div>
        </div>
      </div>
      <div style="width:100%;height:60px;background:#2C445C;display:flex;justify-content:center;align-items:center">
          <div style="width:1000px;height:40px;display:flex;align-items:center;justify-content:space-around;color:white">
            <div>トップページ</div>
          <div>会社情報</div>
          <div>人材募集</div>
          <div>お問合せ</div>
          </div>
      </div>
    </div>
    <div v-if="this.itemIndex == 3">
      <div class="top-rowBanner444444">

        <div style="margin-left:45%">
          <div><img src="../assets/第一生命关于我们繁体_slices/Talent Recruitment@3x.png" alt="" style="width:300px;margin-top:200px"></div>
        <div>
          <!-- <img src="../assets/第一生命关于我们繁体_slices/人才招聘.png" alt="" style="width:100px;margin-left:90px;margin-top:10px"> -->
          <div style="width:100px;margin-left:90px;margin-top:10px;font-size:22px">人材募集</div>
        </div>
        </div>
      </div>
      <!-- 关于我们导航栏 公司概况 品质服务 企业荣誉 企业文化 -->
      <div style="display: flex; justify-content: center; align-items: center">
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 1200px;

            height: 400px;
          "
        >
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
            "
          >
            <div
              style="
                border-bottom: 1px solid grey;
                width: 120px;
                margin-left: 200px;
                display: flex;
                justify-content: center;
                height: 35px;
              "
            >
            雇用形態
            </div>
            <div style="margin-left: 260px">
              <input
                type="checkbox"
                id="option1"
                value="Option1"
                v-model="selectedOption"
              />
              <label for="option1" style="margin-left: 6px">正社員</label>

              <input
                type="checkbox"
                id="option2"
                value="Option2"
                v-model="selectedOption"
                style="margin-left: 40px"
              />
              <label for="option2" style="margin-left: 6px"
                >アルバイト・パ-ト</label
              >
            </div>
          </div>
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
            "
          >
            <div
              style="
                border-bottom: 1px solid grey;
                width: 120px;
                margin-left: 200px;
                display: flex;
                justify-content: center;
                height: 83px;
              "
            >
            職種
            </div>
            <div
              style="
                margin-left: 260px;
                display: flex;
                flex-direction: column;
                align-items: start;
              "
            >
              <div>
                <input
                  type="checkbox"
                  id="option1"
                  value="Option1"
                  v-model="selectedOption"
                />
                <label for="option1" style="margin-left: 6px">薬剤師</label>
              </div>

              <div style="margin-top: 20px">
                <input
                  type="checkbox"
                  id="option2"
                  value="Option2"
                  v-model="selectedOption"
                />
                <label for="option2" style="margin-left: 6px">登録管理者</label>
              </div>
            </div>
          </div>
          <el-button
            type="primary"
            style="
              width: 110px;
              height: 35px;
              font-size: 16px;
              border-radius: 0;
              margin-top: 35px;
              margin-left: 330px;
            "
            >申 請</el-button
          >
        </div>
      </div>
      <!-- footer -->
     <!-- footer -->
     <div
        class="footerBanner"
        style="
          width: 100%;
          height: 300px;

          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 100px;
        "
      >
        <div
          style="
            width: 1000px;
            height: 280px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div style="width:1000px;height:270px;background-color:rgba(254,254,254,0.65);margin-top:30px;display:flex">
         <div>
             <!-- 1 -->
             <div style="display: flex; align-items: center;margin-left:45px;margin-top:25px">
              <img
                src="../assets/第一生命首页繁体_slices/矢量智能对象.png"
                alt=""
                style="width:35px; height:32px"
              />
              <!-- <img
                src="../assets/第一生命首页繁体_slices/第一生命香港有限公司.png"
                alt=""
                style="height: 17px; margin-left: 15px"
              /> -->
              <div  style="height: 17px; margin-left: 15px">
                第一生命香港有限会社
              </div>
            </div>
            <!-- 2 -->
            <div style="width:560px;margin-left:45px;margin-top:20px">
              笑顔で全てのお客様と向き合い、誠意を持ってサービスを提供します。小さなことから始め、細かく携わって、熱意と根気でお客様に満足を、誠意と愛情でお客様を感動を、常に心を込めて接客します。
              <!-- <img src="../assets/香港首页繁体_slices/微笑面对每一位顾客，诚恳服务每一位顾客，从小事做起、从细节着手，用热心和耐心温暖顾客； 用诚心和爱心感动顾客；用心、尽心奉献于.png" alt="" style="width:560px;margin-left:45px;margin-top:28px"> -->
            </div>
            <!-- 3 -->
            <div>
              <img src="../assets/香港首页繁体_slices/中国总公司： 营口博爱医药连锁有限公司：http：／／www.boaiyiyao.com  日本分公司： 株式会社政轩：htt.png" alt="" style="width:320px;margin-left:45px;margin-top:28px" >
            </div>
         </div>
         <div style="margin-left:240px;margin-top:115px;display:flex;align-items:center;flex-direction:column">
          <img src="../assets/香港首页繁体_slices/图层 19.png" alt="">
          <img src="../assets/香港首页繁体_slices/博爱公众号.png" alt="">
         </div>
          </div>
        </div>
      </div>
      <div style="width:100%;height:60px;background:#2C445C;display:flex;justify-content:center;align-items:center">
          <div style="width:1000px;height:40px;display:flex;align-items:center;justify-content:space-around;color:white">
            <div>トップページ</div>
          <div>会社情報</div>
          <div>人材募集</div>
          <div>お問合せ</div>
          </div>
      </div>
    </div>
    <div v-if="this.itemIndex == 5">
      <!-- banner -->
      <div class="top-rowBanner555555"></div>
      <!-- 关于我们导航栏 公司概况 品质服务 企业荣誉 企业文化 -->
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 60px 0;
        "
      >
        <div>お問い合わせ</div>
      </div>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        "
      >
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 1200px;
            border: 1px dashed grey;
            padding: 170px 0;
            height: 400px;
          "
        >
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
              justify-content: space-around;
              align-items: center;
              padding-bottom: 20px;
            "
          >
            <div></div>
            <div></div>
            <div
              style="
                width: 160px;
                display: flex;
                justify-content: start;
                height: 25px;
              "
            >
              名前（姓名）
            </div>
            <div
              style="
                width: 45px;
                height: 25px;
                background: #cf131c;
                display: flex;
                justify-content: center;
                align-items: center;
                color: white;
                border: 1px dashed black;
              "
            >
              必须
            </div>
            <div
              style="
                width: 340px;
                height: 30px;
                border: 1px dashed grey;
                background: #eef2f6;
              "
            ></div>
            <div></div>
            <div></div>
          </div>
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
              justify-content: space-around;
              align-items: center;
              padding-bottom: 20px;
            "
          >
            <div></div>
            <div></div>
            <div
              style="
                width: 160px;
                display: flex;
                justify-content: start;
                height: 25px;
              "
            >
              フリガナ（セイメイ）
            </div>
            <div
              style="
                width: 45px;
                height: 25px;

                display: flex;
                justify-content: center;
                align-items: center;
              "
            ></div>
            <div
              style="
                width: 340px;
                height: 30px;
                border: 1px dashed grey;
                background: #eef2f6;
              "
            ></div>
            <div></div>
            <div></div>
          </div>
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
              justify-content: space-around;
              align-items: center;
              padding-bottom: 20px;
            "
          >
            <div></div>
            <div></div>
            <div
              style="
                width: 160px;
                display: flex;
                justify-content: start;
                height: 25px;
              "
            >
              会社名
            </div>
            <div
              style="
                width: 45px;
                height: 25px;
                background: #cf131c;
                display: flex;
                justify-content: center;
                align-items: center;
                color: white;
                border: 1px dashed black;
              "
            >
              必须
            </div>
            <div
              style="
                width: 340px;
                height: 30px;
                border: 1px dashed grey;
                background: #eef2f6;
              "
            ></div>
            <div></div>
            <div></div>
          </div>
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
              justify-content: space-around;
              align-items: center;
              padding-bottom: 20px;
            "
          >
            <div></div>
            <div></div>
            <div
              style="
                width: 160px;
                display: flex;
                justify-content: start;
                height: 25px;
              "
            >
              お電話番号
            </div>
            <div
              style="
                width: 45px;
                height: 25px;
                background: #cf131c;
                display: flex;
                justify-content: center;
                align-items: center;
                color: white;
                border: 1px dashed black;
              "
            >
              必须
            </div>
            <div
              style="
                width: 340px;
                height: 30px;
                border: 1px dashed grey;
                background: #eef2f6;
              "
            ></div>
            <div></div>
            <div></div>
          </div>
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
              justify-content: space-around;
              align-items: center;
              padding-bottom: 20px;
            "
          >
            <div></div>
            <div></div>
            <div
              style="
                width: 160px;
                display: flex;
                justify-content: start;
                height: 25px;
              "
            >
              メールアドレス
            </div>
            <div
              style="
                width: 45px;
                height: 25px;
                background: #cf131c;
                display: flex;
                justify-content: center;
                align-items: center;
                color: white;
                border: 1px dashed black;
              "
            >
              必须
            </div>
            <div
              style="
                width: 340px;
                height: 30px;
                border: 1px dashed grey;
                background: #eef2f6;
              "
            ></div>
            <div></div>
            <div></div>
          </div>
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
              justify-content: space-around;
              align-items: center;
              padding-bottom: 20px;
            "
          >
            <div></div>
            <div></div>
            <div
              style="
                width: 160px;
                display: flex;
                justify-content: start;
                height: 25px;
              "
            >
              ご希望の連絡方法
            </div>
            <div
              style="
                width: 45px;
                height: 25px;

                display: flex;
                justify-content: center;
                align-items: center;
              "
            ></div>
            <div
              style="
                width: 340px;
                display: flex;
                justify-content: space-between;
              "
            >
              <div
                style="
                  width: 160px;
                  height: 30px;
                  border: 1px dashed grey;
                  background: #eef2f6;
                  line-height: 30px;
                "
              >
                <input
                  style="margin-left: 18px"
                  type="radio"
                  id="option1"
                  value="Option1"
                  v-model="selectedOption1"
                />
                <label for="option1" style="margin-left: 6px">メール</label>
              </div>
              <div
                style="
                  width: 160px;
                  height: 30px;
                  border: 1px dashed grey;
                  background: #eef2f6;
                  line-height: 30px;
                "
              >
                <input
                  style="margin-left: 18px"
                  type="radio"
                  id="option1"
                  value="Option1"
                  v-model="selectedOption1"
                />
                <label for="option1" style="margin-left: 6px">電話</label>
              </div>
            </div>
            <div></div>
            <div></div>
          </div>
          <div
            style="
              width: 1200px;

              margin-top: 30px;
              display: flex;
              justify-content: space-around;
              align-items: center;
              padding-bottom: 20px;
            "
          >
            <div></div>
            <div></div>
            <div
              style="
                width: 160px;
                display: flex;
                justify-content: start;
                height: 25px;
              "
            >
              お問い合わせ内容
            </div>
            <div
              style="
                width: 45px;
                height: 25px;
                background: #cf131c;
                display: flex;
                justify-content: center;
                align-items: center;
                color: white;
                border: 1px dashed black;
              "
            >
              必须
            </div>
            <div
              style="
                width: 340px;
                height: 130px;
                border: 1px dashed grey;
                background: #eef2f6;
              "
            ></div>
            <div></div>
            <div></div>
          </div>
          <div
            style="
              width: 130px;
              background: #cf131c;
              padding: 10px 0;
              color: white;
              display: flex;
              justify-content: center;
              margin-left: 180px;
            "
          >
            送信
          </div>
        </div>
      </div>
      <!-- footer -->
      <div
        style="
          width: 100%;
          height: 300px;
          background: #eef2f6;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 100px;
        "
      >
        <div
          style="
            width: 1200px;
            height: 300px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div>
            <img
              src="../assets/首页_slices/logo.png"
              alt=""
              style="width: 220px"
            />
          </div>
          <div style="border-left: 1px dashed grey; padding-left: 55px">
            <img
              src="../assets/首页_slices/会社情報 事業内容 採用情報 お問い合わせ.png"
              alt=""
            />
          </div>
          <div style="border-left: 1px dashed grey; padding-left: 55px">
            <div>
              <img
                src="../assets/首页_slices/株式会社政轩.png"
                alt=""
                style="height: 25px"
              />
              <img
                src="../assets/首页_slices/Sei Ken Co,Ltd．.png"
                alt=""
                style="height: 16px; margin-left: 10px"
              />
            </div>
            <div>
              <img
                src="../assets/首页_slices/福岡県福岡市中央区春吉３丁目21−21春野ビル５階E.png"
                alt=""
                style="margin-top: 10px"
              />
            </div>
            <div>
              <img
                src="../assets/首页_slices/中国本社： 营口博愛医薬连锁有限公司：http：／／www.boaiyiyao.com 香港支社： 博愛(香港)有限会社：ht.png"
                alt=""
                style="margin-top: 10px"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedOption1: "",
      selectedOption: "",
      showtable: 1,
      itemIndex: 1,
      itemIndexAbout: 1,
      itemIndexVip: 1,
      itemIndexba: 1,
      itemIndexSup: 1,
      itemIndexzp: 1,
      labelPosition: "top",
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
    };
  },

  methods: {
    btnshowtable(index) {
      this.showtable = index;
    },
    btnClick(index) {
      this.itemIndex = index;
    },
    btnClickVip(index) {
      this.itemIndexVip = index;
    },
    btnClickba(index) {
      this.itemIndexba = index;
    },
    btnClickAbout(index) {
      this.itemIndexAbout = index;
    },
    btnClickSup(index) {
      this.itemIndexSup = index;
    },
    btnClickzp(index) {
      this.itemIndexzp = index;
    },
  },
};
</script>
<style scoped>
* {
  padding: 0;
  margin: 0;
}
.nav {
  width: 1100px;
  height: 80px;
  /* background-color: rgb(159, 81, 81); */
  color: black;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}
.banner {
  height: 80px;
  background-color: rgb(245, 228, 228);
  color: black;
  display: flex;
  justify-content: space-between;
}
.center {
  list-style: none;

  /* background-color: pink; */
}
li {
  color: rgb(24, 5, 5);
  float: left;
}
a:hover {
  /* background-color: violet; */
  color: #246ef6;
  text-decoration: underline;
}
a {
  /* 
        一定注意要把a转成行内块元素，
        如果转的是块元素那么短竖线会掉下去，
        因为块级元素是独占一行的
    */
  display: inline-block;
  padding: 0 25px;
  line-height: 80px;
  text-decoration: none;
  color: black;
}

.top-rowBanner {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/香港首页繁体_slices/banner.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 440px;
}
.footerBanner {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/香港首页繁体_slices/图层 18.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 440px;
}
.top-rowBanner1111 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/香港关于我们_slices/banner.png")
    no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 440px;
 

}
.top-rowBanner222222 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/lxwm.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 440px;
}
.top-rowBanner333333 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/banner1.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 440px;
}
.top-rowBanner444444 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/rczp.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 440px;
}
.top-rowBanner555555 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/日本官网-联系_slices/2.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 440px;
}
.top-rowBanner666 {
  background: #f8f8f8;
  /* padding: 3em 0 4em 0; */
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/cjx.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 260px;
}
.top-rowBanner6666 {
  background: #f8f8f8;
  /* padding: 3em 0 4em 0; */
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/join.jpg") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
}
.top-rowBanner1 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/size.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
  margin-top: 35px;
}
.top-rowBanner2 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/indexAbout.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
  /* margin-top:35px; */
}
.top-rowBannerAbout {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/1.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 100px;
  /* margin-top:35px; */
}
.top-rowBanner2222 {
  background: #f8f8f8;
  /* padding: 3em 0 4em 0; */
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: white no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 80px;
  border-bottom: 3px dotted grey;

  /* margin-top:35px; */
}
.top-rowBanner3 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/map.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 220px;
  /* margin-top:35px; */
}
.top-rowBanner5 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/bannerVip.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
  /* margin-top:35px; */
}
.top-rowBanner5555 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/supbanner.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
  /* margin-top:35px; */
}
.top-rowBanner6 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/join.jpg") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
  /* margin-top:35px; */
}
.top-rowBanner544444 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/badsj.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
  /* margin-top:35px; */
}
.togethter {
  background: #f8f8f8;
  padding: 1em 0 1em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/toge.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
  /* margin-top:35px; */
}
.active {
  color: #246ef6;
  text-decoration: underline;
}
.activeShowHos {
  background: #0077c3;
  color: white;
  padding: 10px;
  /* text-decoration: underline; */
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 13px;
}
.activeAbout {
  color: #246ef6;
  text-decoration: underline;
}
</style>